<template>
    <div class="contacter-entire">

        <div class="city-list-wrap">
            <div class="city-list-tab" ref="cityFixedTab" id="cityScroll">
                <div class="city-box flexBox" ref="cityBox">
                    <span class="city-tab-bullet" v-for="(city, index) in cityList" :class="{'active': cityActiveIndex == index}" @click="clickTab(index, true)">
                        <span v-text="city.ShortName"></span>
                    </span>
                </div>
            </div>
        </div>

        <div class="city-contact-list" ref="citycontactlist">
            <template v-for="lists in cityContactList">
                <contact-list :city="lists.CityName" :lists="lists.PeopleList" :has2500="has2500"></contact-list>
            </template>
        </div>

        <div class="gap-filling" :style="{'height': gapHeight + 'px'}" style="background: #f0f1f2;"></div>
    </div>
</template>

<script>
    import contactList from '../components/contactList'
    import { SEARCH } from '../api'
    export default {
        name: 'contacts',
        data () {
            return {
                tagId: this.$route.params.tagId || sessionStorage.tagId,
                cityActiveIndex: 0,
                cityList: [],
                cityContactList: [],
                scr_t: 0,
                main_position: null,
                gapHeight: 0,
                has2500: this.$route.params.has_2500
            }
        },
        mounted () {

            this.$route.params.tagId ? sessionStorage.tagId = this.$route.params.tagId : ''

            this.$nextTick( () => {
                this.cityScroll = new iScroll("cityScroll", {
                    vScroll: false,
                    fadeScrollbar: false
                })
            })
            this.GetAllTagContact()

            this.scrollWatch()
        },
        methods: {
            clickTab (index, cityPosition) {
                this.cityActiveIndex = index
                // tab定位
                this.cityTabPosition(index)
                this.cityContactPosition(index)
                // setTimeout( () => {
                //     this.main_position = 'scroll'
                // }, 500)
                // if (cityPosition) {
                //     // 城市联系人定位
                //     this.cityContactPosition(index)
                // }
            },
            cityTabPosition (index, cb) {  // tab定位
                var fontSize = document.getElementsByTagName('html')[0].style.fontSize
                var htmlFontSize = Number(fontSize.split('px')[0])
                var win_w = window.innerWidth || document.documentElement.clientWeight

                var lDistance = this.lDistance(index)
                var rDistance = this.rDistance(index)
                var containerW = this.$refs.cityFixedTab.offsetWidth + 0.6667 * htmlFontSize
                var swiperTabW  = this.$refs.cityBox.getElementsByClassName('city-tab-bullet')[index].offsetWidth
                var halfDistance = (containerW - swiperTabW) / 2
                
                if (lDistance < halfDistance) {  // 左边宽度不足以滑到中间
                    this.cityScroll.scrollTo(0, 0, 500)
                    return
                }
                if (lDistance >= halfDistance && rDistance >= halfDistance) {
                    var dd = halfDistance - this.lDistance(index)
                    this.cityScroll.scrollTo(dd, 0, 500)
                    return
                }

                if (lDistance >= halfDistance && rDistance < halfDistance) {  // 右边宽度不足以滑到中间
                    var dd = containerW - this.$refs.cityBox.getElementsByClassName('city-tab-bullet')[0].offsetWidth - this.rDistance(0) - 0.6667 * htmlFontSize
                    this.cityScroll.scrollTo(dd, 0, 500)
                    return
                }
            },
            cityContactPosition (index) {  // 城市联系人定位
                const fontSize = document.getElementsByTagName('html')[0].style.fontSize
                const htmlFontSize = Number(fontSize.split('px')[0])
                var offsetTop = this.$refs.citycontactlist.getElementsByClassName('city-contact')[index].offsetTop
                window.scrollTo(0, offsetTop - 1.4933 * htmlFontSize - 0.4533 * htmlFontSize)
            },
            scrollWatch () {  // 监听滚动
                const fontSize = document.getElementsByTagName('html')[0].style.fontSize
                const htmlFontSize = Number(fontSize.split('px')[0])
                const ll = 1.4933 * htmlFontSize + 0.4533 * htmlFontSize
                var oLists = this.$refs.citycontactlist.getElementsByClassName('city-contact')
                document.getElementById('app').addEventListener('scroll', (event) => {
                    // if (this.$route.name !== 'contacts' && this.main_position === 'click') return
                    if (this.$route.name !== 'contacts') return

                    this.scr_t = document.getElementById('app').scrollTop

                    for (let index = 0; index < oLists.length; index++) {
                        if (oLists[index].offsetTop - this.scr_t - ll <= 10 || this.scr_t - ll - oLists[index].offsetTop >= -10) {
                            this.cityActiveIndex = index
                            // this.clickTab(index, false)
                            this.cityTabPosition(index)
                            this.main_position = 'click'
                        }
                    }
                })
            },
            lDistance (goalIndex) {  // 获取目标tab左边的总距离

                let lGapWidth = 0, lElemWidth = 0
                var fontSize = document.getElementsByTagName('html')[0].style.fontSize
                var htmlFontSize = Number(fontSize.split('px')[0])
                var oFTabBullet = this.$refs.cityBox.getElementsByClassName('city-tab-bullet')
                for (let i = 0; i < goalIndex; i++) {
                    lGapWidth += 0.6667 * htmlFontSize
                    lElemWidth += oFTabBullet[i].offsetWidth
                }

                return lGapWidth + lElemWidth + 0.6667 * htmlFontSize
            },
            rDistance (goalIndex) {  // 获取目标tab左边的总距离

                let rGapWidth = 0, rElemWidth = 0, loopLength = this.cityList.length
                var fontSize = document.getElementsByTagName('html')[0].style.fontSize
                var htmlFontSize = Number(fontSize.split('px')[0])
                var oFTabBullet = this.$refs.cityBox.getElementsByClassName('city-tab-bullet')
                for (let i = goalIndex + 1; i < loopLength; i++) {
                    rGapWidth += 0.6667 * htmlFontSize
                    rElemWidth += oFTabBullet[i].offsetWidth
                }

                return rGapWidth + rElemWidth
            },
            GetAllTagContact () {  // 获取所有联系人
                SEARCH.GetAllTagContact({
                    TagId: this.tagId,
                    Location: localStorage.cityName
                }).then( (res) => {
                    this.cityList = res.Data.CityList
                    this.cityContactList = res.Data.CityPeopleList
                    this.$nextTick( () => {
                        this.cityScroll.refresh()
                        const fontSize = document.getElementsByTagName('html')[0].style.fontSize
                        const htmlFontSize = Number(fontSize.split('px')[0])
                        const ll = 1.4933 * htmlFontSize + 0.4533 * htmlFontSize
                        let win_h = window.innerHeight || document.documentElement.clientHeight
                        var oLists = this.$refs.citycontactlist.getElementsByClassName('city-contact')
                        var offsetTop = oLists[res.Data.CityPeopleList.length - 1].offsetTop
                        var offsetHeight = oLists[res.Data.CityPeopleList.length - 1].offsetHeight
                        this.gapHeight = win_h - ll - offsetHeight - 0.4 * htmlFontSize + 50
                    })
                })
            }
        },
        components: {
            contactList
        }
    }
</script>

<style lang="scss" scope>
    .contacter-entire {
        .city-list-wrap {
            position: fixed;
            top: 0;
            left: 0; right: 0;
            z-index: 6;
            height: j(112);
            background-color: #fff;
            padding-left: j(50);
            // padding-right: j(138);
            overflow: hidden;
            pointer-events: auto;
            box-shadow: 0 0 15px 0 rgba(0, 0, 0, .08);
            &.border {
                border-bottom: 1px solid rgba(0, 0, 0, .08);
            }
            .city-list-tab {
                position: relative;
                height: j(112);
                white-space: nowrap;
                .city-box {
                    height: 100%;
                    .city-tab-bullet {
                        font-weight: bold;
                        font-size: j(28);
                        display: inline-block;
                        height: 100%;
                        line-height: j(112);
                    }
                    .city-tab-bullet.active {
                        color: #00bebe;
                        position: relative;
                        &:after {
                            content: '';
                            position: absolute;
                            bottom: 0; 
                            left: 50%;
                            width: j(36);
                            height: j(3);
                            margin-left: j(-18);
                            background: #00bebe;
                        }
                    }
                    .city-tab-bullet + .city-tab-bullet {
                        margin-left: j(50);
                    }
                }
                .city-box + div {
                    display: none;
                }
            }
        }
        .city-contact-list {
            margin: j(112 + 34) j(30) j(30);
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/contactEntire.vue